import { render, staticRenderFns } from "./TaskChangeCommentDeleted.vue?vue&type=template&id=607d7b50&scoped=true&lang=pug&"
import script from "./TaskChangeCommentDeleted.vue?vue&type=script&lang=js&"
export * from "./TaskChangeCommentDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d7b50",
  null
  
)

export default component.exports